export interface PrintModeState {
  isPrinting: boolean;
}

export const initialState: PrintModeState = {
  isPrinting: false,
};
